import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';

import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';

export const AllPayPeriodsDoc = gql`
  query AllPayPeriods {
    all_pay_periods {
      edges {
        node {
          id
          range_display
          state
        }
      }
    }
  }
`;

const AllPayPeriods = graphql(AllPayPeriodsDoc, {
  props: ({ ownProps, data }) => {
    const payPeriods = querySelector(data, 'all_pay_periods.edges[*].node', []);
    return {
      ...ownProps,
      payPeriods,
      data,
    };
  },
});

export const withAllPayPeriods = compose(
  AllPayPeriods,
  queryMetaHandler,
);

export const PayPeriodFragment = gql`
  fragment PayPeriodFragment on PayPeriod {
    id
    state
    sage_csv_path
    user_timesheets(state: unapproved) {
      count
      edges {
        node {
          id
          start_date {
            display
          }
          user {
            id
            fullname
            supervisor {
              id
              fullname
            }
          }
        }
      }
    }
  }
`;

export const PayPeriodMissingTicketsFragment = gql`
  fragment PayPeriodMissingTicketsFragment on PayPeriod {
    id
    missing_ticket_numbers {
      id
      number
      created_at {
        date
      }
    }     
  }
`;

export const PayPeriodDetailsDoc = gql`
  query PayPeriodDetails($payPeriodId: Int!) {
    pay_period(pay_period_id: $payPeriodId) {
      ...PayPeriodFragment
      ...PayPeriodMissingTicketsFragment
    }
  }
  ${PayPeriodFragment}
  ${PayPeriodMissingTicketsFragment}
`;

const mapDataToProps = withProps((props) => {
  const { pay_period: payPeriod } = props.data;
  const isPayPeriodOpened = payPeriod.state === 'opened';
  const isPayPeriodClosed = payPeriod.state === 'closed';
  const isPayPeriodFinalized = payPeriod.state === 'finalized';
  const eligibleForClose = payPeriod.user_timesheets.count === 0;
  // TODO use query selector

  const userTimesheets = payPeriod.user_timesheets.edges;

  const [allMissingTicketNumbers] = querySelector(props.data, 'pay_period.missing_ticket_numbers', []);
  return {
    payPeriod,
    isPayPeriodOpened,
    isPayPeriodClosed,
    isPayPeriodFinalized,
    eligibleForClose,
    userTimesheets,
    allMissingTicketNumbers,
  };
});

const withData = graphql(PayPeriodDetailsDoc);

const enhance = compose(
  withData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);

export const withPayPeriodDetails = enhance;
